import { cn } from "cn";
import type { ReactNode } from "react";

type SummaryRowProps = {
  label: ReactNode;
  value: ReactNode;
  /** `success` greens the value — the offer discount and nothing else, today. */
  tone?: "default" | "success";
  /** The `Due today` weight: the one figure the buyer is committing to. */
  emphasis?: boolean;
  /** Sits under the row, e.g. "You saved $250.00". */
  caption?: ReactNode;
  className?: string;
};

/**
 * One row of the cart ledger. Every row a cart renders goes through here, so the
 * member card and its presale twin cannot drift apart on spacing or weight.
 */
export function SummaryRow({
  label,
  value,
  tone = "default",
  emphasis = false,
  caption,
  className,
}: SummaryRowProps) {
  return (
    <div className={cn("px-4 py-3", className)}>
      <div
        className={cn(
          /* sorted */
          "flex",
          "items-center justify-between gap-2",
          "text-text-dark-high text-sm",
          {
            "text-text-success": tone === "success",
            "text-text-dark-max text-base font-medium": emphasis,
          },
        )}
      >
        <p>{label}</p>
        <p className={cn(tone === "success" && "text-text-success")}>{value}</p>
      </div>
      {caption && (
        <p className="text-xs leading-4 font-normal text-text-success">
          {caption}
        </p>
      )}
    </div>
  );
}
